import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import { STUDIO } from '@/content/studio';

/**
 * Band 6 — STUDIO INTRO. Black band; who we are, one CTA to /studio.
 */

const StudioBand = () => {
    return (
        <section className="hb-studio" aria-label="About the studio">
            <Reveal>
                <h2 className="hb-studio-heading">{STUDIO.introHeading}</h2>
                <p className="hb-studio-body">{STUDIO.introBody}</p>
                <Link to="/studio" className="hb-studio-cta">
                    MEET THE STUDIO <span aria-hidden="true">→</span>
                </Link>
            </Reveal>

            <style>{`
                .hb-studio {
                    background: #000;
                    padding: var(--by) var(--bx);
                }
                .hb-studio-heading {
                    font-family: var(--font-display);
                    font-weight: 700;
                    font-size: clamp(3rem, 9vw, 8rem);
                    line-height: 0.9;
                    text-transform: uppercase;
                    color: #fff;
                    margin: 0 0 clamp(1.2rem, 3vw, 2rem);
                }
                .hb-studio-body {
                    font-family: var(--font-family);
                    font-size: clamp(1.02rem, 1.6vw, 1.3rem);
                    line-height: 1.6;
                    color: var(--color-text-secondary);
                    max-width: 52ch;
                    margin: 0 0 clamp(1.8rem, 4vw, 2.8rem);
                }
                .hb-studio-cta {
                    display: inline-flex;
                    align-items: center;
                    gap: 0.6rem;
                    min-height: 44px;
                    padding: 0 1.4rem;
                    border: 1px solid #fff;
                    color: #fff;
                    font-family: var(--font-family);
                    font-size: 0.8rem;
                    font-weight: 700;
                    letter-spacing: 0.16em;
                    transition: background var(--transition-fast), color var(--transition-fast);
                }
                .hb-studio-cta:hover {
                    background: #fff;
                    color: #000;
                }
            `}</style>
        </section>
    );
};

export default StudioBand;
